import {
  Box,
  Button,
  Grid,
  InputAdornment,
  Popover,
  TextField,
  Typography,
} from "@mui/material";
import { AppLayout } from "layout";
import React from "react";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

const AccountRoleDropdown = ({
  activeDropdown,
  setAccountRole,
  accountRole,
  onAccountChange,
  onClearAll,
}: any) => {
  const handleClick = () => {
    setAccountRole(3); // 2 is the index for this dropdown
  };
  const handleAccountSelection = (role: any) => {
    onAccountChange(role);
    setAccountRole(null);
  };
  return (
    <Grid display={"flex"} flexDirection={"column"} position={"relative"}>
      <Box onClick={handleClick} sx={styleSheet.CategoriesContainer}>
        {/* <img src="/assets/icons/category.png" alt="search" /> */}
        Account Role
      </Box>
      {activeDropdown == 3 && (
        <Box
          sx={{
            position: "absolute",
            top: "100%",
            zIndex: 1,
            width: { xs: "100%", md: 123 },
            bgcolor: "background.paper",
            borderRadius: "8px",
            mt: 1,
            p: 2,
          }}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            gap={2}
            fontSize={"17px"}
            fontWeight={400}
            color={onAccountChange ? "#797979" : "#233F91"}
          >
            {[
              "Content-Creator",
              "Standard-User",
              "Admin",
            ].map((role) => (
              <Typography
                key={role}
                onClick={() => handleAccountSelection(role)}
                sx={{
                  cursor: "pointer",
                  color: accountRole === role ? "#233F91" : "#797979", // ✅ Change color if selected

                }}
              >
                {role}
              </Typography>
            ))}

            <Box display="flex" alignItems="center" mb={2}>
              <Button
                variant="outlined"
                onClick={() => {
                  onClearAll(); // Trigger clear all
                  setAccountRole(null); // Close dropdown
                }}
              >
                Clear
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </Grid>
  );
};

export default AccountRoleDropdown;

const styleSheet = {
  CategoriesContainer: {
    backgroundColor: "white",
    borderRadius: "15px",
    padding: "10px 10px",
    display: "flex",
    gap: 1,
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: "17px",
    fontWeight: "400px",
    // width: "122px",
    width: "116px",
    color: "#233F91",
    fontFamily: "Atten Round New",
  },
};
